import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'adminapp-upload-zip-modal',
  templateUrl: './upload-modal-window.component.html',
  styleUrls: ['./upload-modal-window.component.scss']
})
export class ModalComponent {
  @Input() fileZip1;
  @Output() cancel = new EventEmitter<void>();
  constructor() { }

  onCancel() {
    if (this.cancel) {
      this.cancel.emit();
    }
  }
}
